import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { DefaultButton, PrimaryButton } from 'office-ui-fabric-react/lib-commonjs/Button';
import { SpinButton } from 'office-ui-fabric-react/lib-commonjs/SpinButton';
import { TooltipHost } from 'office-ui-fabric-react/lib-commonjs/Tooltip';
import { Toggle } from 'office-ui-fabric-react/lib-commonjs/Toggle';
import { Label } from 'office-ui-fabric-react/lib-commonjs/Label';
import {
  backgroundEdit,
  backgroundFileSelected,
  backgroundLoaded,
  backgroundShowHide,
  chamberRowSpacingValueChange,
  clearRulersOnScreen,
  measureToolEditSwitch,
  scaleEditSwitch,
  scaleUnitValueChange,
} from '../../actions/drawingtoolbar-actions';
import { IMPERIAL, METRIC } from '../../lib/types';
import './index.css';
import './drawing-toolbar.css';
import PopUpHelper from '../Calculations/popUpHelper.component';
import {
  getPlanScaleInchesByState,
  getPlanScaleMtsByState,
  getScalePixelsByState,
  getScaleValueByState,
} from '../../lib/calculations';
import { emitLineLenght } from '../../actions/scaleline-actions';
import { getScaledValue } from '../../actions/calculations-actions';
import {
  getStagePosition,
  getStageScale,
  positionStage,
  scaleStage,
  switchPanning,
} from '../../actions/viewport-actions';
import Dialog, { DialogFooter, DialogType } from 'office-ui-fabric-react/lib-commonjs/Dialog';
import ProjectSelectors from '../../reducers/project-reducer';
import { modalAlertActions } from '../../actions/modal-alert.actions';
import ADSDefaultButton from '../ADSDefaultButton/ADSDefaultButton';
import ScaleService from '../../lib/services/scale-service';
import {
  loadingBed,
  setDirtyStateForMultiBeds,
  setUpdatePerimeterOnBed,
  showScaleMultiBedWarningDialog,
  startRescaleMultibeds,
  updatePlaceholder,
} from '../../actions/multi-bed-actions';
import { clearViewPort, setCurrentSubProject } from '../../actions/sub-project-actions';
import { clearMainManifoldsState } from '../../actions/manifold-actions';
import { getSubProjectStateToPersist, restoreSubProjectPersistedState } from '../../actions/sub-project-crud-actions';
import { buildPipeProjectAutomation, buildProjectAutomation } from '../../actions/submit-dialog-actions';
import MultibedSelectors from '../../reducers/multi-bed-reducer';
import SubProjectService from '../../lib/services/sub-project-service';
import MultiBedService from '../../lib/services/multibed-service';
import { computeStoneBed } from '../../actions/floating-tool-actions';
import ManifoldSelectors from '../../reducers/main-manifold-reducer';
import { getStateToPersist } from '../../actions/project-crud-actions';
import {
  newBackgroundRequestedClick,
  setBackgroundMovedTransformed,
  showBackgroundMultiBedWarningDialog,
} from '../../actions/background-actions';
import { DialogContent } from 'office-ui-fabric-react';
import { setPipeDesign } from '../../actions/pipe-bed-actions';
import {
  setPlanScaleInchesChamber,
  setPlanScaleInchesPipe,
  setPlanScaleMtsChamber,
  setPlanScaleMtsPipe,
  setProjectsUrlInvalidDialog,
} from '../../actions/generic-globals.actions';
import { Button } from 'primereact/button';

class DrawingToolbar extends PureComponent {
  state = {
    changeColor: true,
    isDirectSelected: true,
    planScaleInches: 1,
    planScaleFeet: 22,
    planScaleMts: 350,
    measureLength: 0,
    pdfDataLoaded: false,
    pdfPageSizes: {
      ptWidth: 0,
      ptHeight: 0,
      inWidth: 0,
      inHeight: 0,
      mmWidth: 0,
      mmHeight: 0,
    },
    imgPageSizes: {
      width: 0,
      height: 0,
    },
    showDirectScaleWarning: false,
    allowSetScaleDirect: false,
    setScaleDirectValue: 0,
    showChangeMultiBedBackgroundWarning: false,
  };

  async componentDidUpdate(prevProps, prevState) {
    if (this.props.scalingImageDataPresent && this.props.pdfPageSizes !== prevProps.pdfPageSizes) {
      this.setState({ pdfPageSizes: this.props.pdfPageSizes });
    }

    if (this.props.scalingImageDataPresent && this.props.imgPageSizes !== prevProps.imgPageSizes) {
      this.setState({ imgPageSizes: this.props.imgPageSizes });
      this.setState({ pdfDataLoaded: true });
      if (
        this.props.imgPageSizes.width !== 0 && //Do only if changed size
        this.props.imgPageSizes.height !== 0 &&
        this.props.bgRotation === 0 && // Cant apply if the image is rotated
        !this.props.isRestoredProject // Cant apply if the image is just loaded
      )
        setTimeout(() => this.handleSetScaleBtn(), 0); // Execute scaling this.props.isRestoredProject
    }

    let lengthResult = this.getScaledValue(this.props.measureToolPixels).toFixed(2);
    if (prevProps.measureToolPixels !== this.props.measureToolPixels && !isNaN(this.props.measureToolPixels)) {
      this.setState({
        measureLength: this.props.unit === METRIC ? (lengthResult / 3.28084).toFixed(2) : lengthResult,
      });
    }

    // reset on units change
    if (this.props.unit !== prevProps.unit) {
      this.setState({
        measureLength: this.props.unit === METRIC ? (lengthResult / 3.28084).toFixed(2) : lengthResult,
      });
    }

    if (this.props.rescaleMultibeds) {
      this.props.startRescaleMultibeds(false);
      this.handleSetScaleBtn(false, 'direct').then(() => {
        this.props.startRescaleMultibeds(false);
      });
    }

    if (
      this.props.isBackgroundMovedTransformed !== prevProps.isBackgroundMovedTransformed &&
      this.props.isBackgroundMovedTransformed
    ) {
      this.props.loadingBed(true);
      await MultiBedService.syncMultibedAutomationData('background', {}, this.props);
      this.props.setBackgroundMovedTransformed(false);
      this.props.setDirtyStateForMultiBeds(true);
      this.props.loadingBed(false);
    }

    let { scaleValue, scalePixels, planScaleInches, planScaleMts } = this.props.scaleData;
    let {
      scaleValue: prevScaleValue,
      scalePixels: prevScalePixels,
      planScaleInches: prevPlanScaleInches,
      planScaleMts: prevPlanScaleMts,
    } = prevProps.scaleData;

    if (scaleValue) {
      if (scaleValue !== prevScaleValue) {
        // console.log("planScaleFeet", this.state.planScaleFeet, scaleValue);
        this.setState({ planScaleFeet: scaleValue });
      }
    }

    if (planScaleInches) {
      if (planScaleInches !== prevPlanScaleInches) {
        // console.log("planScaleInches >>>>>>>>>>>>", this.state.planScaleInches);
        this.setState({ planScaleInches: planScaleInches });
      }
    }

    if (planScaleMts) {
      if (planScaleMts !== prevPlanScaleMts) {
        // console.log("planScaleMts >>>>>>>>", this.state.planScaleMts);
        this.setState({ planScaleMts: planScaleMts });
      }
    }
  }

  getScaledValue(value) {
    return this.props.scaleValue * (value / this.props.scalePixels);
  }

  /**
   *  Converts ft to metric - but should divide, its multiplying
   * @param val
   * @returns {*}
   */
  convertValues(val) {
    let newVal = 0;
    switch (this.props.unit) {
      case IMPERIAL:
        newVal = val;
        break;
      case METRIC:
        newVal = val * 3.28084;
        break;
      default:
        newVal = val;
    }
    return newVal;
  }

  /**
   *  Converts ft to metric
   *  Was created to correct the value multiplication on convertValues
   *  This was done to avoid introducing a regresion, we dont know why that was made on 2019-07
   * @param val
   * @returns {*}
   */
  convertUnitValues(val) {
    return this.props.unit === METRIC ? val / 3.28084 : val;
  }

  validateScaleUnit(value) {
    let pixels = this.props.scalePixels + 1;
    let ratio = value / pixels;
    /* validate pixels > value */
    if (ratio < 0.02 || ratio / value >= 0.9) {
      alert(`Feet to pixel ratio is too small, resulting drawing would be uninterpretable.`);
      return false;
    }
    return true;
  }

  handleFileUpload() {
    this.props.clearRulersOnScreen();
    if (this.props.isMultiBedProject) {
      this.props.showBackgroundMultiBedWarningDialog(false);
      this.setState({
        showChangeMultiBedBackgroundWarning: true,
      });
      this.uploadFile();
    } else {
      this.uploadFile();
    }
  }

  uploadFile() {
    /* this object reference */
    let self = this;
    /* open upload dialog */
    this.flUpload.click();
    /* on change set the image background blob state */
    this.flUpload.onchange = function (event) {
      /* get the file */
      let file = event.target.files[0];
      /* if was cancelled */
      if (!file) {
        return;
      }
      self.props.backgroundFileSelected(file);
      /* reset the value so we can fire the event
            again with same file name */
      event.target.value = null;
      self.props.newBackgroundRequestedClick(true);
    };
  }

  handleScaleEditClick() {
    this.props.clearRulersOnScreen(); //Clears scale and measurement rulers
    if (this.props.isPanning) this.props.switchPanning();
    this.setState({ measureLength: 0 });
    this.props.scaleEditSwitch(this.props.scaleEdit);
  }

  handleSwitchDirectReference(isDirectSelected) {
    this.props.clearRulersOnScreen(); //Clears scale and measurement rulers
    this.setState({
      isDirectSelected: !isDirectSelected,
      showDirectScaleWarning: true,
    });
  }

  handleMeasureToolEditClick() {
    this.props.clearRulersOnScreen(); //Clears scale and measurement rulers
    if (this.props.isPanning) this.props.switchPanning();
    this.setState({ measureLength: 0 });
    this.props.measureToolEditSwitch(this.props.measureToolEdit);
  }

  handleScaleUnitValueChange(change) {
    /* get scale feet unit */
    let scaleValue = this.props.scaleValue;
    /* if change is in bounds, compute and return */
    if (scaleValue + change >= 1 && this.validateScaleUnit((scaleValue += change))) {
      scaleValue += change;
      this.setState({
        allowSetScaleDirect: true,
        setScaleDirectValue: scaleValue,
      });
    } else {
      this.setState({ allowSetScaleDirect: false });
      return String(scaleValue);
    }
  }

  handleScaleUnitValueOnValidate(value, evt) {
    let newVal = this.convertValues(value);
    if (isNaN(newVal)) {
      return `${this.props.scaleValue}`;
    }

    /* get the integer value */
    newVal = parseFloat(newVal);

    /* if valid unit value */
    if (newVal >= 1 && this.validateScaleUnit(newVal)) {
      this.setState({
        allowSetScaleDirect: true,
        setScaleDirectValue: newVal,
      });
      if (evt && evt.key && evt.key === 'Enter') {
        setTimeout(() => this.handleSetScaleBtn(true, 'reference'), 0);
      }
      return `${newVal}`;
    } else {
      this.setState({ allowSetScaleDirect: false });
      return `${this.props.scaleValue}`;
    }
  }

  handleScaleInchesValueChange(change, inchesValue) {
    const current = parseInt(inchesValue, 10);
    const val = current + change >= 0 ? current + change : 0;
    this.setState({ planScaleInches: val });
    if (this.props.glProjectType === 'CHAMBER') {
      this.props.setPlanScaleInchesChamber(val);
    } else {
      console.log('PIPE');
      this.props.setPlanScaleInchesPipe(val);
    }
  }

  handleScaleInchesValueOnValidate(inchesValue) {
    const current = parseInt(inchesValue, 10);
    const val = current >= 0 ? current : 0;
    this.setState({ planScaleInches: val });
    if (this.props.glProjectType === 'CHAMBER') {
      this.props.setPlanScaleInchesChamber(val);
    } else {
      this.props.setPlanScaleInchesPipe(val);
    }
  }

  handleScaleFeetValueChange(change, feetValue) {
    const current = parseInt(feetValue, 10);
    this.setState({ planScaleFeet: current + change >= 0 ? current + change : 0 });
  }

  handleScaleFeetValueOnValidate(feetValue) {
    const current = parseInt(feetValue, 10);
    this.setState({ planScaleFeet: current >= 0 ? current : 0 });
  }

  handleScaleMetricValueChange(change, metricValue) {
    const current = parseInt(metricValue, 10);
    const val = current + change >= 0 ? current + change : 0;
    this.setState({ planScaleMts: val });
    if (this.props.glProjectType === 'CHAMBER') {
      this.props.setPlanScaleMtsChamber(val);
    } else {
      this.props.setPlanScaleMtsPipe(val);
    }
  }

  handleScaleFeetMetricValueOnValidate(metricValue) {
    const current = parseInt(metricValue, 10);
    const val = current >= 0 ? current : 0;
    this.setState({ planScaleMts: val });
    if (this.props.glProjectType === 'CHAMBER') {
      this.props.setPlanScaleMtsChamber(val);
    } else {
      this.props.setPlanScaleMtsPipe(val);
    }
  }

  showSetScaleDialog() {
    this.setState({
      showDirectScaleWarning: true,
    });
  }

  /**
   * Will adjust scale provided by the IN and Feet input on the Direct screen, will require an uploaded PDF file
   * Can also be triggered on componentDidUpdate()
   */
  async handleSetScaleBtn(showWarning, executionType = 'direct') {
    this.props.showBackgroundMultiBedWarningDialog(false);
    this.props.showScaleMultiBedWarningDialog(false);
    if (executionType === 'direct') {
      this.props.clearRulersOnScreen(); //Clears scale and measurement rulers
      const self = this;

      /**
       * Calculate number of screen pixels
       * @param imgPageSizes
       * @param pdfPageSizes
       * @returns {number}
       * @private
       */
      const _getPixelsLengthInches = (imgPageSizes, pdfPageSizes) => {
        const POINTS_TO_PIXELS = 1.3333;
        const calculatedPixels = self.props.imperialUnit
          ? (imgPageSizes.width / pdfPageSizes.inWidth) * POINTS_TO_PIXELS * this.state.planScaleInches
          : (imgPageSizes.width / pdfPageSizes.inWidth) * this.state.planScaleInches;

        return calculatedPixels;
      };

      /**
       * Correct to proper scaling before they click the OK button
       * @param pixels
       * @returns {*}
       * @private
       */
      const _fixScalingPixels = (pixels) => {
        if (this.props.pdfPageSizes.inWidth && this.props.pdfPageSizes.inWidth) {
          const width = this.props.pdfPageSizes.inWidth;
          switch (true) {
            case width > 9 && width <= 15.99: // 11in
              return pixels - 0.5;
            case width > 16 && width <= 25.99: // 24in
              return pixels - 23.8125;
            case width >= 26 && width <= 35.99: // 34in
              return pixels - 23;
            case width >= 36 && width <= 42.99: // 36in
              return pixels - 23.12;
            case width >= 43: // over 43
              return pixels - 23;
            default:
              return pixels;
          }
        }
        return pixels;
      };

      const _setScaleOnLoad = (value) => {
        this.setState({
          setScaleDirectValue: value,
        });
      };

      /**
       * Emit the proper value of pixels
       * @param setPixels - Number of pixels in one inch
       * @returns void
       * @private
       */
      const _setPixelsLength = (setPixels) => {
        const self = this;
        setTimeout(() => {
          if (self.props.scalePixels === 300) {
            self.props.emitLineLenght(Number(setPixels));
          } else {
            self.props.emitLineLenght(Number(self.props.scalePixels));

            if (!this.props.isMultiBedProject) {
              setTimeout(() => {
                _setScaleOnLoad(30);
                self.props.emitLineLenght(Number(self.props.scalePixels));
              }, 3000);
            }
          }
        }, 100);
      };
      /* lets set Scale */
      const pdfPageSizes = this.props.pdfPageSizes;
      const imgPageSizes = this.props.imgPageSizes;
      if (
        this.props.scalingImageDataPresent &&
        this.state.pdfDataLoaded &&
        this.props.imgPageSizes.width !== 0 &&
        this.props.imgPageSizes.height !== 0
      ) {
        if (this.props.unit !== METRIC) {
          //IMPERIAL
          this.props.scaleUnitValueChange(this.convertUnitValues(this.state.planScaleFeet));
          _setPixelsLength(_fixScalingPixels(_getPixelsLengthInches(imgPageSizes, pdfPageSizes)));
        } else {
          //METRIC
          this.props.scaleUnitValueChange(this.state.planScaleMts / 12);
          _setPixelsLength(_getPixelsLengthInches(imgPageSizes, pdfPageSizes));
        }
      } else {
        // This is used to control the scales when no image has loaded
        if (this.props.unit !== METRIC) {
          this.props.emitLineLenght(150 * this.state.planScaleInches);
          this.props.scaleUnitValueChange(this.convertUnitValues(this.state.planScaleFeet));
        } else {
          this.props.emitLineLenght(150);
          let scaling = this.state.planScaleMts; // 300
          const valueFt = (30 * scaling) / 300;
          this.props.scaleUnitValueChange(valueFt);
        }
      }
    } else {
      if (this.state.allowSetScaleDirect) {
        this.props.scaleUnitValueChange(this.state.setScaleDirectValue);
      }
    }

    if (this.props.isMultiBedProject) {
      // First save current project
      const currentBed = MultibedSelectors.getCurrentBed();
      const config = { bedName: currentBed.name };
      const subProjectInstance = await SubProjectService.saveOrCreateSubProject(currentBed.id, config, this.props);
      await SubProjectService.syncAutomationProcess(subProjectInstance, this.props);

      let placeholderObj = MultiBedService.getPlaceholderSettings(currentBed.name, this.props);
      placeholderObj.bedId = currentBed.id;
      this.props.updatePlaceholder(placeholderObj);

      await this.syncMultibedStates();
    }
    this.props.scaleEditSwitch(true);
  }

  async syncMultibedStates() {
    try {
      this.props.loadingBed(true);
      const syncBeds = [...MultibedSelectors.getAllBeds()];
      let tmpBed = [syncBeds[0]];
      let placeholderObj, projectInstance;
      for (let bed of syncBeds) {
        placeholderObj = undefined;
        projectInstance = undefined;
        await SubProjectService.clearViewPortForMultiBed(this.props);
        projectInstance = await SubProjectService.loadSubProject(bed.id, this.props);

        if (projectInstance.projectType === 'PIPE') {
          const { length, width } = this.props.pipeBed.dimensions;
          this.props.setPipeDesign(width.ft, length.ft);
        }

        await ScaleService.setScale(this.props);
        await ScaleService._waitFor(2000);
        // Save the current placeholder
        placeholderObj = MultiBedService.getPlaceholderSettings(bed.name, this.props);
        placeholderObj.bedId = bed.id;
        this.props.updatePlaceholder(placeholderObj);
        this.props.setUpdatePerimeterOnBed(true);

        await ScaleService._waitFor(1000);

        // Save current bed
        const config = { bedName: bed.bedName };
        const subProjectInstance = await SubProjectService.saveOrCreateSubProject(bed.id, config, this.props);
        await SubProjectService.syncAutomationProcess(subProjectInstance, this.props);
      }
      // Save main project
      await SubProjectService.saveMainProject(this.props);
      this.props.loadingBed(false);
      this.props.setDirtyStateForMultiBeds(false);
      this.props.startRescaleMultibeds(false);
      return true;
    } catch (error) {
      console.error('Error on ScaleService.syncMultibedStates() :: ', error.message);
      this.props.startRescaleMultibeds(false);
      return false;
    }
  }

  confirmChangeScaleOrBackground = () => {
    if (this.state.isDirectSelected) {
      this.handleSetScaleBtn(true, 'direct');
    } else {
      this.handleSetScaleBtn(true, 'reference');
    }
  };

  render() {
    const { changeColor, isDirectSelected, planScaleInches, planScaleFeet, planScaleMts } = this.state;

    const { lbl, unit, lang, content, scaleValue, isMultiBedProject, isOnOverviewTab } = this.props;

    const displayIt = this.props.scalingImageDataPresent ? 'inherit' : 'none';

    const disableForMultiBed = isMultiBedProject;

    const toggleColor = () => {
      this.setState({ changeColor: !changeColor });
    };

    const convertUnits = (value, unitType) => {
      let unitValue = 0;
      switch (unit) {
        case METRIC:
          switch (unitType) {
            case 'ft':
              unitValue = parseFloat(Math.round(value * 0.3048 * 100) / 100).toFixed(2);
              break;
            default:
              unitValue = Math.round(value * 100) / 100;
              break;
          }
          break;
        case IMPERIAL:
          unitValue = Math.round(value * 100) / 100;
          break;
        default:
          break;
      }
      return unitValue;
    };

    const renderImportBlock = () => {
      return (
        <React.Fragment>
          <div style={{ display: 'flex' }} className="ms-Grid-row">
            <div className="ms-Grid-col">
              <TooltipHost content={content[lang].importBackgroundImage} calloutProps={{ gapSpace: 0 }}>
                <ADSDefaultButton
                  disabled={!isOnOverviewTab}
                  className={'import-button'}
                  data-automation-id="background"
                  text={content[lang].importPDF}
                  iconProps={{ iconName: 'ImageCrosshair' }}
                  style={!isOnOverviewTab ? css.disabled : changeColor ? css.default : css.changed}
                  onClick={() => {
                    if (this.props.isMultiBedProject) this.props.showBackgroundMultiBedWarningDialog(true);
                    else this.handleFileUpload();
                  }}
                />
              </TooltipHost>
            </div>
          </div>
          <div style={{ height: '10px' }} />
          <div className="ms-Grid-row">
            <div className="ms-Grid-col ms-sm12 ms-md12 ms-lg12 ms-xl12 ms-xxl12">
              <Toggle
                checked={this.props.bgEdit}
                onText={content[lang].moveRotate}
                offText={content[lang].moveRotate}
                disabled={!this.props.bgImg}
                data-automation-id="background"
                onClick={() => {
                  this.props.newBackgroundRequestedClick(false);
                  this.props.backgroundEdit(this.props.bgEdit);
                }}
                className={'ms-Toggle_green_back'}
              />
            </div>
            <div className="ms-Grid-col ms-sm12 ms-md12 ms-lg12 ms-xl12 ms-xxl12">
              <Toggle
                checked={this.props.bgShow}
                iconProps={{ iconName: 'Processing' }}
                disabled={!this.props.bgImg}
                onText={content[lang].showHide}
                offText={content[lang].showHide}
                onClick={() => this.props.backgroundShowHide(this.props.bgShow)}
                className={'ms-Toggle_green_back'}
              />
            </div>
          </div>

          <hr style={{ display: displayIt }} />
          <br style={{ display: displayIt }} />

          <div style={{ display: 'flex' }} className="ms-Grid-row">
            {this.props.scalingImageDataPresent ? (
              <div className="ms-Grid-col ms-sm12 ms-md12 ms-l12 ms-xl12 ">
                {content[lang].scaling} : &nbsp;
                <DefaultButton
                  disabled={!isOnOverviewTab}
                  primary={isDirectSelected}
                  data-automation-id="switchDirect"
                  text={content[lang].direct}
                  onClick={() => this.handleSwitchDirectReference(isDirectSelected)}
                />
                &nbsp;
                <DefaultButton
                  disabled={!isOnOverviewTab}
                  style={{ padding: '0px' }}
                  primary={!isDirectSelected}
                  data-automation-id="switchReference"
                  text={content[lang].reference}
                  onClick={() => this.handleSwitchDirectReference(isDirectSelected)}
                />
              </div>
            ) : null}
          </div>
        </React.Fragment>
      );
    };

    const renderDirectImperial = () => {
      return this.props.scalingImageDataPresent ? (
        <div className="ms-Grid-row">
          <div className="ms-Grid-col ms-sm12 ms-md12 ms-l3 ms-xl3">
            <Label>{content[lang].enterPlanScale}</Label>
          </div>
          <div className="ms-Grid-col ms-sm3 ms-md3 ms-l3 ms-xl3">
            <div className="ms-Grid-row">
              <SpinButton
                disabled={!isOnOverviewTab}
                min={'1'}
                step={1.0}
                className="scale-plan-inputs"
                value={convertUnits(planScaleInches, 'in')}
                onIncrement={this.handleScaleInchesValueChange.bind(this, 1)}
                onDecrement={this.handleScaleInchesValueChange.bind(this, -1)}
                onValidate={this.handleScaleInchesValueOnValidate.bind(this)}
                label={lbl[unit].in[lang] + ':'}
                labelPosition={1}
              />
            </div>
          </div>
          <div className="ms-Grid-col ms-sm3 ms-md3 ms-l3 ms-xl3">
            <div className="ms-Grid-row">
              <SpinButton
                disabled={!isOnOverviewTab}
                min={'1'}
                step={0.5}
                className="scale-plan-inputs"
                value={convertUnits(planScaleFeet, 'ft')}
                onIncrement={this.handleScaleFeetValueChange.bind(this, 1)}
                onDecrement={this.handleScaleFeetValueChange.bind(this, -1)}
                onValidate={this.handleScaleFeetValueOnValidate.bind(this)}
                label={lbl[unit].ft[lang]}
                labelPosition={1}
              />
            </div>
          </div>
          <div className="ms-Grid-col ms-sm3 ms-md3 ms-l3 ms-xl3 set-scale-btn-container">
            <ADSDefaultButton
              disabled={!isOnOverviewTab}
              primary={true}
              className="scale-plan-btn primary_green_ads"
              text={content[lang].ok}
              onClick={() => {
                if (this.props.isMultiBedProject) this.props.showScaleMultiBedWarningDialog(true);
                else this.handleSetScaleBtn(true, 'direct');
                this.showSetScaleDialog();
              }}
            />
          </div>
        </div>
      ) : null;
    };

    const renderDirectMetric = () => {
      return this.props.scalingImageDataPresent ? (
        <div className="ms-Grid-row">
          <div className="ms-Grid-col    ms-sm4 ms-md4 ms-l4 ms-xl4">
            <label>{content[lang].enterPlanScale}</label>
          </div>
          <div
            className="ms-Grid-col  ms-sm4 ms-md4 ms-l4 ms-xl4"
            style={{
              padding: '5px',
            }}>
            <div className={'scale-plan-metric'}>
              <SpinButton
                disabled={!isOnOverviewTab}
                min={'1'}
                step={1.0}
                className="scale-plan-inputs_metric"
                value={planScaleMts}
                onIncrement={this.handleScaleMetricValueChange.bind(this, 1)}
                onDecrement={this.handleScaleMetricValueChange.bind(this, -1)}
                onValidate={this.handleScaleFeetMetricValueOnValidate.bind(this)}
                label={'1: '}
                labelPosition={0}
              />
            </div>
          </div>
          <div className="ms-Grid-col    ms-sm1 ms-md1 ms-l1 ms-xl1">&nbsp;</div>
          <div className="ms-Grid-col  ms-sm3 ms-md3 ms-l3 ms-xl3">
            <DefaultButton
              disabled={!isOnOverviewTab}
              primary={true}
              className="scale-plan-btn primary_green_ads"
              style={{
                minWidth: '35px',
                maxWidth: '35px',
                padding: '2px',
                marginTop: '5px',
              }}
              text={content[lang].ok}
              onClick={() => {
                if (this.props.isMultiBedProject) this.props.showScaleMultiBedWarningDialog(true);
                else this.handleSetScaleBtn(true, 'direct');

                this.showSetScaleDialog();
              }}
            />
          </div>
        </div>
      ) : null;
    };

    const renderReference = () => {
      return (
        <React.Fragment>
          <div style={{ display: 'flex' }} className="ms-Grid-row">
            <div style={{ display: 'flex' }} className="ms-Grid-row">
              <div className="ms-Grid-col ms-sm12 ms-md12 ms-lg12 ms-xl12">
                <DefaultButton
                  disabled={!isOnOverviewTab}
                  primary={this.props.scaleEdit}
                  data-automation-id="editScale"
                  iconProps={{ iconName: 'SizeLegacy' }}
                  text={content[lang].setScale}
                  onClick={() => this.handleScaleEditClick()}
                />
              </div>
              <div className="questionMark" style={{ display: 'inline-block' }}>
                <PopUpHelper title={content[lang].scaling} text={content[lang].scalingInstructions} />
              </div>
            </div>
          </div>
          <br />
          <div style={{ display: 'flex', paddingTop: '5px' }} className="ms-Grid-row">
            <div className="ms-Grid-col ms-sm4 ms-md4 ms-l4 ms-xl4" style={{ width: '85px' }}>
              <Label>{content[lang].enterMeasuredLength}</Label>
            </div>
            <div className="ms-Grid-col ms-sm4 ms-md4 ms-l4 ms-xl4">
              <SpinButton
                disabled={!isOnOverviewTab}
                min={'1'}
                step={1.0}
                value={convertUnits(scaleValue, 'ft')}
                onValidate={this.handleScaleUnitValueOnValidate.bind(this)}
                onIncrement={this.handleScaleUnitValueChange.bind(
                  this,
                  unit === IMPERIAL
                    ? 0.5 // Step 1 by 1 (feet)
                    : 1.64042, // Step 1 by 1 (meter)
                )}
                onDecrement={this.handleScaleUnitValueChange.bind(
                  this,
                  unit === IMPERIAL
                    ? -0.5 // Step 1 by 1 (feet)
                    : -1.64042, // Step 1 by 1 (meter)
                )}
              />
            </div>
            <div className="ms-Grid-col ms-sm2 ms-md2 ms-l2 ms-xl2">
              <Label>{lbl[unit].ft[lang]}</Label>
            </div>
            <div className="ms-Grid-col ms-sm2 ms-md2 ms-l2 ms-xl2">
              <ADSDefaultButton
                disabled={!isOnOverviewTab}
                primary={true}
                className="scale-plan-btn primary_green_ads"
                style={{
                  minWidth: '35px',
                  maxWidth: '35px',
                  padding: '2px',
                  marginTop: '5px',
                }}
                text={content[lang].ok}
                onClick={() => {
                  if (this.props.isMultiBedProject) this.props.showScaleMultiBedWarningDialog(true);
                  else this.handleSetScaleBtn(true, 'reference');
                }}
              />
            </div>
          </div>
        </React.Fragment>
      );
    };

    const renderMeasureBlock = () => {
      return (
        <React.Fragment>
          <div className="ms-Grid-row">
            {/* START - The background hidden file upload */}
            <input
              type="file"
              ref={(node) => {
                this.flUpload = node;
              }}
              name="upload"
              accept="application/pdf"
              style={{ display: 'none' }}
            />
            {/* The background hidden file upload - END */}
            {/*<div style={{ paddingTop: "5px", display: "flex" }}>
                            <Label>
                                {content[lang].measure}:
                            </Label>
                            <div className="questionMark" style={{ display: "inline-block", paddingLeft: "5px" }}>
                                <PopUpHelper
                                    title={content[lang].distanceMeasured}
                                    text={content[lang].distanceMeasuredInstructions}/>
                            </div>
                        </div>*/}
          </div>
          <div className="ms-Grid-row" style={{ width: '100%' }}>
            <div className="ms-Grid-col ms-sm6 ms-md6 ms-l6 ms-xl6 " style={{ width: 'fit-content' }}>
              <ADSDefaultButton
                primary={this.props.measureToolEdit}
                data-automation-id="editScale"
                text={content[lang].measure}
                onClick={() => this.handleMeasureToolEditClick()}
                className={'primary_green_ads'}
                style={{ maxWidth: '10rem' }}
              />
              <div className="questionMark" style={{ display: 'inline-block', marginLeft: '5px', paddingTop: '8px' }}>
                <PopUpHelper title={content[lang].measure} text={content[lang].meassureExplination} />
              </div>
            </div>

            <div className="ms-Grid-col ms-sm6 ms-md6 ms-l6 ms-xl6">
              <div className="measurement-input-container">{this.state.measureLength}</div>
              <Label>{lbl[unit].ft[lang]}</Label>
            </div>
          </div>
        </React.Fragment>
      );
    };

    const renderDirectScaleWarning = () => {
      return (
        <Dialog
          hidden={!this.state.showDirectScaleWarning}
          dialogContentProps={{
            type: DialogType.normal,
          }}
          modalProps={this.state.modalProps}
          onDismiss={() => {
            this.setState({ showDirectScaleWarning: false });
          }}>
          <div>
            <p>{content[lang].directScaleWarning}</p>
          </div>
          <DialogFooter>
            <PrimaryButton
              onClick={() => {
                this.setState({ showDirectScaleWarning: false });
              }}
              text={content[lang].ok}
            />
          </DialogFooter>
        </Dialog>
      );
    };

    const renderMultibedScaleWarning = () => {
      return (
        <Dialog
          hidden={!this.props.showScaleMultiBedWarning}
          dialogContentProps={{
            type: DialogType.normal,
            titleId: 'multi-bed-dialog-title',
            title: content[lang].multibedScaleTitleWarning,
          }}
          modalProps={{
            className: 'multi-bed-dialog',
            containerClassName: 'multi-bed-dialog-container',
          }}
          onDismiss={() => this.props.showScaleMultiBedWarningDialog(false)}>
          <DialogContent>
            <p className="dialog-info">{content[lang].multibedScaleWarning}</p>
          </DialogContent>
          <DialogFooter>
            <div className="multi-bed-dialog-input-container">
              <PrimaryButton text={content[lang].continue} onClick={this.confirmChangeScaleOrBackground.bind(this)} />
              <DefaultButton
                text={content[lang].cancel}
                onClick={() => this.props.showScaleMultiBedWarningDialog(false)}
                className={'caution_blue_ads'}
              />
            </div>
          </DialogFooter>
        </Dialog>
      );
    };

    const renderMultibedBackgroundWarning = () => {
      return (
        <Dialog
          hidden={!this.props.showBackgroundMultiBedWarning}
          dialogContentProps={{
            type: DialogType.normal,
            titleId: 'multi-bed-dialog-title',
            title: content[lang].changeMultiBedBackgroundWarningTitle,
          }}
          modalProps={{
            className: 'multi-bed-dialog',
            containerClassName: 'multi-bed-dialog-container',
          }}
          onDismiss={() => this.props.showBackgroundMultiBedWarningDialog(false)}>
          <DialogContent>
            <p className="dialog-info">{content[lang].multibedScaleWarning}</p>
          </DialogContent>
          <DialogFooter>
            <div className="multi-bed-dialog-input-container">
              <PrimaryButton
                text={content[lang].continue}
                onClick={() => {
                  this.props.showBackgroundMultiBedWarningDialog(false);
                  this.handleFileUpload();
                }}
              />
              <DefaultButton
                text={content[lang].cancel}
                onClick={() => {
                  this.props.showBackgroundMultiBedWarningDialog(false);
                }}
                className={'caution_blue_ads'}
              />
            </div>
          </DialogFooter>
        </Dialog>
      );
    };

    const renderChangeMultiBedBackgroundWarning = () => {
      return (
        <Dialog
          //hidden={!this.state.showChangeMultiBedBackgroundWarning}
          hidden={true}
          dialogContentProps={{
            type: DialogType.normal,
            title: content[lang].changeMultiBedBackgroundWarningTitle,
          }}
          onDismiss={() => this.setState({ showChangeMultiBedBackgroundWarning: false })}>
          <div>
            <p>{content[lang].changeMultiBedBackgroundWarning}</p>
          </div>
          <DialogFooter>
            <PrimaryButton
              onClick={() => {
                this.setState({ showChangeMultiBedBackgroundWarning: false });
                this.uploadFile();
              }}
              text={content[lang].ok}
            />
          </DialogFooter>
        </Dialog>
      );
    };

    const renderProjectsLinkInvalidWarning = () => {
      return (
        <Dialog
          hidden={!this.props.showProjectUrlInvalid}
          dialogContentProps={{
            type: DialogType.normal,
            title: '',
          }}
          onDismiss={() => this.props.setProjectsUrlInvalidDialog(false)}>
          <div>
            <p>{content[lang].projectUrlInvalid}</p>
          </div>
          <DialogFooter>
            <PrimaryButton
              onClick={() => {
                this.props.setProjectsUrlInvalidDialog(false);
              }}
              text={content[lang].ok}
            />
          </DialogFooter>
        </Dialog>
      );
    };

    return (
      <React.Fragment>
        {renderDirectScaleWarning()}
        {renderMultibedBackgroundWarning()}
        {renderMultibedScaleWarning()}
        {renderProjectsLinkInvalidWarning()}
        {renderImportBlock()}
        <br />
        {isDirectSelected
          ? this.props.unit !== METRIC
            ? renderDirectImperial()
            : renderDirectMetric()
          : renderReference()}
        {!this.props.scalingImageDataPresent ? renderReference() : null}
        <br />
        <hr style={{ display: displayIt }} />
        {renderMeasureBlock()}
      </React.Fragment>
    );
  }
}

const css = {
  default: {
    color: 'white',
    minWidth: '40px',
    backgroundColor: ' #0C92CD',
  },
  changed: {
    color: 'white',
    minWidth: '40px',
    backgroundColor: '#218838',
  },
  forced_width: {
    width: '85px !important',
  },
  disabled: {
    backgroundColor: 'rgb(244, 244, 244)',
    color: 'rgb(166, 166, 166)',
  },
};

const mapStateToProps = (state) => {
  let scaleData = {};
  if (state.project && state.project.project && state.project.project.projectType) {
    scaleData['projectType'] = state.project.project.projectType;
    scaleData['scaleValue'] =
      state.project.project.projectType === 'CHAMBER' ? state.globals.scaleValue : state.pipeGlobals.scaleValue;
    scaleData['scalePixels'] =
      state.project.project.projectType === 'CHAMBER' ? state.globals.scalePixels : state.pipeGlobals.scalePixels;
    scaleData['planScaleInches'] =
      state.project.project.projectType === 'CHAMBER'
        ? state.globals.planScaleInches
        : state.pipeGlobals.planScaleInches;
    scaleData['planScaleMts'] =
      state.project.project.projectType === 'CHAMBER' ? state.globals.planScaleMts : state.pipeGlobals.planScaleMts;
  } else {
    scaleData = {};
  }

  return {
    /* General states */
    lbl: state.localization.lbl,
    unit: state.localization.unit,
    isPanning: state.viewport.isPanning,

    bgRotation: state.background.rotation,
    bgImg: state.background.bgImg,
    bgShow: state.background.bgShow,
    appliedScale: state.background.appliedScale,

    /* Own states */
    bgEdit: state.drawingToolbar.bgEdit,
    scaleEdit: state.drawingToolbar.scaleEdit,
    chmBedPresent: state.drawingToolbar.chmBedPresent,
    measureToolEdit: state.drawingToolbar.measureToolEdit,
    measureToolPixels: state.debugingtool.measureToolPixels,

    /* these two metrics comes from global reducer */
    projectType: state.globals.projectType,
    chamberType: state.globals.chamberType,
    drawingMode: state.globals.drawingMode,
    globalScalePixels: state.globals.scalePixels,
    glScaleValue: state.globals.scaleValue,
    glPlanScaleInches: state.globals.planScaleInches,
    glPlanScaleMts: state.globals.planScaleMts,
    glScalePixels: state.globals.scalePixels,
    isRestoredProject: state.globals.isRestoredProject,
    scaleValue: getScaleValueByState(state),
    scalePixels: getScalePixelsByState(state),
    planScaleInches: getPlanScaleInchesByState(state),
    planScaleMts: getPlanScaleMtsByState(state),

    enableDebuging: state.globals.enableDebuging,
    chamberRowSpacing: state.globals.chamberRowSpacing,
    chamberEndCapType: state.globals.chamberEndCapType,

    /* Pdf states*/
    pdfPageSizes: state.pdf.pdfPageSizes,
    imgPageSizes: state.pdf.imgPageSizes,
    imperialUnit: state.pdf.imperialUnit,

    scalingImageDataPresent: state.pdf.scalingImageDataPresent,

    isMultiBedProject: ProjectSelectors.isMultiBedProject(),
    isOnOverviewTab: state.multiBed.isOnOverviewTab,

    resourcesTokens: state.authentication.resourcesTokens,
    user: state.authentication.user,
    scaleData: scaleData,

    stoneBedPoints: state.stonebed.points,
    chamberbedX: state.chamberbed.x,
    chamberbedY: state.chamberbed.y,
    pipeBedPosition: state.pipeBed.position,
    chamberbedRotation: state.chamberbed.rotation,
    pipeBedRotation: state.pipeBed.rotation,
    chamberbedHeight: state.chamberbed.height,
    chamberbedWidth: state.chamberbed.width,
    pipeBedDimensions: state.pipeBed.dimensions,
    chamberbedScaleX: state.chamberbed.scaleX,
    chamberbedScaleY: state.chamberbed.scaleY,

    //saveOrCreateSubProject
    project: state.project.project,
    glProjectType: state.globals.projectType,
    region: state.localization.region,

    updatePerimeterOnBed: state.multiBed.updatePerimeterOnBed,
    chamberRowSpacingPixels: state.globals.chamberRowSpacingPixels,
    underdrain: state.calculations.underdrain,
    manifoldSeparations: state.calculations.manifoldSeparations,

    chamberRows: state.chamberbed.chamberRows,
    upperManifolds: ManifoldSelectors.getManifoldsByType('upper'),
    lowerManifolds: ManifoldSelectors.getManifoldsByType('lower'),

    sepDistance: state.stonebed.sepDistance,
    rescaleMultibeds: state.multiBed.rescaleMultibeds,
    showScaleMultiBedWarning: state.multiBed.showScaleMultiBedWarning,
    showBackgroundMultiBedWarning: state.background.showBackgroundMultiBedWarning,
    isBackgroundMovedTransformed: state.background.backgroundMovedTransformed,

    pipeBed: state.pipeBed,
    showProjectUrlInvalid: state.globals.showProjectUrlInvalid,
  };
};

const mapDispatchToProps = {
  backgroundEdit,
  scaleEditSwitch,
  backgroundLoaded,
  backgroundShowHide,
  scaleUnitValueChange,
  measureToolEditSwitch,
  backgroundFileSelected,
  chamberRowSpacingValueChange,
  emitLineLenght,
  clearRulersOnScreen,
  getScaledValue,
  switchPanning,
  modalAlertActions,
  loadingBed,
  clearViewPort,
  setCurrentSubProject,
  clearMainManifoldsState,
  restoreSubProjectPersistedState,

  getStageScale,
  getStagePosition,
  scaleStage,
  positionStage,
  updatePlaceholder,

  setPipeDesign,

  getSubProjectStateToPersist,
  buildProjectAutomation,
  buildPipeProjectAutomation,
  setDirtyStateForMultiBeds,
  setUpdatePerimeterOnBed,
  computeStoneBed,
  getStateToPersist,
  startRescaleMultibeds,
  newBackgroundRequestedClick,
  showScaleMultiBedWarningDialog,
  showBackgroundMultiBedWarningDialog,
  setBackgroundMovedTransformed,

  setPlanScaleInchesChamber,
  setPlanScaleInchesPipe,
  setPlanScaleMtsChamber,
  setPlanScaleMtsPipe,

  setProjectsUrlInvalidDialog,
};

/* export this contained component */
export default connect(mapStateToProps, mapDispatchToProps)(DrawingToolbar);



// WEBPACK FOOTER //
// ./src/components/Toolbars/drawing-toolbar.js